import React from 'react';

const SlideModal = ({ isOpen, onClose, title, children }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" 
         style={{
           position: 'fixed',
           top: 0,
           left: 0,
           right: 0,
           bottom: 0,
           backgroundColor: 'rgba(0, 0, 0, 0.75)',
           display: 'flex',
           justifyContent: 'center',
           alignItems: 'center',
           zIndex: 1000
         }}>
      <div className="modal-content" 
           style={{
             backgroundColor: '#fff',
             borderRadius: '10px',
             width: '80%',
             maxWidth: '900px',
             maxHeight: '90vh',
             overflow: 'auto',
             position: 'relative',
             padding: '2rem',
             boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)'
           }}>
        <button 
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '15px',
            right: '15px',
            background: 'none',
            border: 'none',
            fontSize: '24px',
            cursor: 'pointer',
            color: '#4B0082'
          }}
        >
          ×
        </button>
        <h2 style={{ 
          marginBottom: '1.5rem',
          color: '#4B0082',
          textAlign: 'center'
        }}>{title}</h2>
        {children}
      </div>
    </div>
  );
};

export default SlideModal;
